kv.controller('roleTypeListCtrl', function ($element, $attrs, $scope, $injector) {
	return new dictionaryListCtrl($element, $attrs, $scope, $injector, {
		primaryKey: "role_type_id",
		entity: "role_type",
		modal: {
			templateUrl: "role_type-edit",
			controller: "roleTypeEditCtrl"
		}
	});
});
